import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from 'infrastructure/common/model/api.query';

@Injectable({ providedIn: 'root' })
export class MustAnswerOnBoardingModuleApiQuery extends ApiQuery<
	boolean,
	void
> {
	client = 'content';
	document = gql`
		query MustAnswerOnBoardingModule {
			mustAnswerOnBoardingModule
		}
	`;
	method = 'mustAnswerOnBoardingModule';
}
